module.exports = __webpack_public_path__ + "static/media/bg-image.24852c9d.jpg";